import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, tap } from 'rxjs';

import { QuotationInsert, Quotation, QuotationSearchCommand } from '../../models/order/quotation';
import { ApiResponse } from '@card-software/nexus-utilities';

@Injectable({
  providedIn: 'root',
})
export class QuotationProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.orderApi + '/api/v1/quotation';

  public insertQuotation(quotation: QuotationInsert): Observable<ApiResponse<Quotation>> {
    return this.httpClient.post<ApiResponse<Quotation>>(`${this.baseUrl}`, quotation);
  }

  public updateQuotation(quotation: QuotationInsert): Observable<ApiResponse<Quotation>> {
    return this.httpClient.put<ApiResponse<Quotation>>(`${this.baseUrl}/${quotation.id}`, quotation);
  }

  public search(command: QuotationSearchCommand): Observable<ApiResponse<Quotation[]>> {
    return this.httpClient.post<ApiResponse<Quotation[]>>(`${this.baseUrl}/search`, command);
  }

  public getById(id: string): Observable<ApiResponse<Quotation>> {
    return this.httpClient.get<ApiResponse<Quotation>>(`${this.baseUrl}/${id}`);
  }
  public deleteQuotation(id: string): Observable<ApiResponse<Quotation>> {
    return this.httpClient.delete<ApiResponse<Quotation>>(`${this.baseUrl}/${id}`).pipe(
      tap((res) => {
        console.log(res);
      }),
    );
  }

  public uploadItemFile(quotationId: string, itemId: string, file: File) {
    const formData = new FormData();
    formData.append('files', file, file.name);

    const params = new HttpParams().append('quotationId', quotationId).append('itemId', itemId);

    return this.httpClient.post(`${this.baseUrl}/upload-files`, formData, { params });
  }
}
